const ar = {
  contact: {
    heroHeading: 'تواصل معنا',
    heroSub: 'سواء كنت تشتري، تبيع، أو تستثمر — فريقنا هنا لمساعدتك في كل خطوة.',
    expertsBadge: 'تعرّف على خبرائنا',
    expertsHeading: 'الأشخاص خلف Victory Homes',
    officeLabel: 'موقع المكتب',
    phoneLabel: 'أرقام الهاتف',
    phoneOffice: 'المكتب',
    phoneWA: 'اتصل / واتسآب',
    emailLabel: 'راسلنا',
    followLabel: 'تابعنا',
    formHeading: 'أرسل لنا رسالة',
    formSub: 'املأ النموذج وسيرد عليك فريقنا خلال 24 ساعة.',
    fieldName: 'اسمك *',
    fieldEmail: 'البريد الإلكتروني *',
    fieldPhone: 'رقم الهاتف',
    fieldSubject: 'الموضوع',
    fieldMessage: 'رسالتك *',
    sendBtn: 'إرسال',
    sentBtn: '\u2713 تم الإرسال!',
    thankYou: 'شكرًا لك! سنرد خلال 24 ساعة.',
  },
  mort: {
    heroBadge: 'خدمات الرهن العقاري',
    heroLine1: 'حلول رهن عقاري في الإمارات',
    heroAccent: 'مصممة خصيصًا لك',
    heroSub: 'احسب دفعتك الشهرية، تحقق من أهليتك، واستكشف منتجات الرهن من 15+ بنك إماراتي — كل شيء في مكان واحد.',
    tabCalc: '📊 حاسبة الرهن',
    tabElig: '✅ فحص الأهلية',
    loanParams: 'معاملات القرض',
    propertyValue: 'قيمة العقار',
    downPayment: 'الدفعة المقدمة',
    annualRate: 'معدل الفائدة السنوي',
    loanTenure: 'مدة القرض',
    years: (n) => `${n} سنوات`,
    minDown: '20% (حد أدنى)',
    maxUAE: '25 سنة (أقصى في الإمارات)',
    monthlyEMI: 'القسط الشهري',
    loanAmount: 'مبلغ القرض',
    totalInterest: 'إجمالي الفائدة',
    totalPayable: 'إجمالي المدفوع',
    principalVsInterest: 'الأصل مقابل الفائدة',
    principal: 'الأصل',
    interest: 'الفائدة',
    compareRates: '🏦 مقارنة معدلات بنوك الإمارات',
    amortSchedule: '📅 جدول الاستهلاك السنوي',
    basedOnLoan: (amt, yrs) => `بناءً على قرضك بمبلغ ${amt} درهم لمدة ${yrs} سنة. المعدلات توضيحية — تواصل معنا للحصول على أسعار حية.`,
    bankCol: 'البنك',
    fixedRate3yr: 'معدل ثابت (3 سنوات)',
    variableEIBOR: 'متغير (EIBOR+)',
    monthlyEMIFixed: 'القسط الشهري (ثابت)',
    totalCost: 'إجمالي التكلفة',
    eibor3mNote: (rate) => `* EIBOR 3شهور: ${rate}% (معدل مرجعي). تتغيّر المعدلات المتغيرة دوريًا.`,
    yearCol: 'السنة',
    principalPaid: 'الأصل المدفوع',
    interestPaid: 'الفائدة المدفوعة',
    balanceRemaining: 'الرصيد المتبقي',
    yearRow: (n) => `السنة ${n}`,
    financialProfile: 'ملفك المالي',
    residencyStatus: 'حالة الإقامة',
    residencyOpts: [
      { value: 'resident',    label: '🏠 مقيم في الإمارات',   desc: '80% LTV · 25 سنة' },
      { value: 'national',    label: '🇦🇪 مواطن إماراتي',   desc: '85% LTV · 25 سنة' },
      { value: 'nonresident', label: '✈️ غير مقيم',    desc: '50% LTV · 15 سنة' },
    ],
    yourAge: 'عمرك',
    ageUnit: 'سنة',
    monthlySalary: 'الراتب الشهري (درهم)',
    otherIncome: 'دخل شهري آخر',
    existingEMI: 'أقساط قروض حالية (درهم/شهر)',
    creditCard: 'حد بطاقة الائتمان (درهم)',
    ccNote: 'تحتسب البنوك 5% من الحد كعبء شهري',
    assumedRate: 'معدل الفائدة المفترض',
    checkBtn: '🔍 تحقق من أهليتي',
    fillDetails: 'أدخل بياناتك',
    fillDesc: 'بناءً على قواعد DBR للبنك المركزي للإمارات، سنحسب لك أقصى رهن مؤهل عبر بنوك الإمارات.',
    errTitle: 'تعذّر تقدير الأهلية',
    errDesc: 'قد تتجاوز التزاماتك الحد المسموح 50% أو عمرك لا يتيح مدة كافية. تواصل مع مستشارينا.',
    maxLoan: 'أقصى مبلغ قرض',
    maxProperty: 'أقصى قيمة عقار',
    minDownPay: 'أدنى دفعة مقدمة',
    maxTenure: 'أقصى مدة قرض',
    maxEMI: 'أقصى قسط شهري مسموح',
    dbrTitle: 'تحليل DBR للبنك المركزي',
    grossIncome: 'إجمالي الدخل الشهري',
    existingObligs: 'الالتزامات الحالية',
    dbrHeadroom: 'هامش DBR (50%)',
    ltvApplied: 'LTV المطبّق',
    dbrNote: 'النتائج استرشادية. الأهلية الفعلية تخضع لتقييم البنك والدرجة الائتمانية.',
    readyApply: 'مستعد للتقديم؟',
    readyApplyDesc: 'سيؤمن لك مستشارونا أفضل معدل عبر 15+ بنكًا إماراتيًا.',
    talkAdvisor: 'تحدث مع مستشار →',
    servicesBadge: 'خدماتنا',
    servicesHeading: 'كل ما تحتاجه تحت سقف واحد',
    servicesSub: 'Victory Homes تتعامل مع كبرى بنوك الإمارات لتقديم خدمات رهن شفافة وسريعة.',
    services: [
      { icon: '🏠', title: 'رهن سكني', desc: 'موّل منزل أحلامك بمعدلات تنافسية من كبرى البنوك.' },
      { icon: '✈️', title: 'رهن غير المقيمين', desc: 'تعيش خارج الإمارات وتريد الاستثمار هنا؟ نرتّب لك رهنًا بحد تمويل 50%.' },
      { icon: '🔄', title: 'إعادة شراء وتحرير حقوق الملكية', desc: 'تدفع كثيرًا على رهنك الحالي؟ انتقل بنكًا ووفّر آلاف الدراهم.' },
      { icon: '🏗️', title: 'تمويل الأراضي والبناء', desc: 'منتجات متخصصة لتمويل الأراضي ومشاريع البناء.' },
      { icon: '📋', title: 'تقييم الأهلية مجانًا', desc: 'نقيّم ملفك ونوفّر خطاب تأهيل مسبق عبر 5+ بنوك.' },
      { icon: '👤', title: 'مستشار رهن شخصي', desc: 'كل عميل يحصل على مستشار مخصص يرافقه من التقديم حتى الموافقة.' },
    ],
    ctaHeading: 'مستعد للخطوة التالية؟',
    ctaSub: 'مستشارونا العقاريون جاهزون لمساعدتك على تأمين أفضل صفقة. استشارة مجانية، بدون التزام.',
    ctaBtn: 'احجز استشارة مجانية →',
  },
  offplan: {
    heroBadge: '\u2726 عقارات دبي على الخارطة',
    heroLine1: 'استثمر قبل',
    heroAccent: 'أن تتحرك المدينة.',
    heroSub: 'وصول حصري قبل الإطلاق إلى أبرز مشاريع دبي. احجز وحداتك بأسعار اليوم — قبل أن يتحرك السوق.',
    browseBtn: 'تصفح المشاريع',
    advisorBtn: 'تحدث مع مستشار',
    statGrowth: 'متوسط نمو رأس المال',
    statVisa: 'حد التأهيل للتأشيرة الذهبية',
    statComm: 'عمولة على المشتري',
    whyBadge: 'لماذا على الخارطة',
    whyHeading: 'خيار المستثمر الذكي',
    why: [
      { icon: '\ud83d\udcb0', title: 'سعر دخول منخفض', desc: 'اشتربأسعار ما قبل الإطلاق — أقل عادةً 20\u201330\u0025 من قيمة السوق عند الاكتمال.' },
      { icon: '\ud83d\udcc5', title: 'خطط دفع مرنة', desc: 'يوفر المطورون خطط 40/60 أو 20/80 — وزع استثمارك عبر فترة البناء.' },
      { icon: '\ud83d\udcc8', title: 'ارتفاع رأس المال', desc: 'حققت عقارات دبي على الخارطة تاريخياً نموًا 30\u201350\u0025 من الإطلاق حتى التسليم.' },
      { icon: '\ud83e\ude99', title: 'مؤهلة للتأشيرة الذهبية', desc: 'عقارات 2م درهم إماراتي+ تؤهل للتأشيرة الذهبية 10 سنوات.' },
    ],
    featuredBadge: 'مشاريع مختارة',
    featuredHeading: 'مشاريع على الخارطة مختارة بعناية',
    catalogueLink: 'طلب الكتالوج الكامل \u2190',
    showingOf: (shown, total) => `عرض ${shown} من ${total} مشروع`,
    noMatchTitle: 'لم يتم العثور على عقارات مطابقة',
    noMatchDesc: 'حاول توسيع نطاق البحث أو تقليل الفلاتر.',
    clearFilters: 'مسح جميع الفلاتر',
    communitiesBadge: 'استكشف المجتمعات',
    communitiesHeading: 'أكثر مناطق دبي جاذبية',
    seeListings: 'عرض جميع العقارات \u2190',
    locations: [
      { name: 'Downtown', desc: ['وسط أيقوني أحياء دبي، يجسد داونتاون جوهر الحياة الحضرية الرفيعة.', 'صالات استقبال فاخرة وتراسات بانورامية تطل على أبرز معالم المدينة.'] },
      { name: 'Palm Jumeirah', desc: ['جزيرة نخلة جميرا تجمع بين التراث والأناقة العصرية.', 'مسكن مصمم بعناية وفضاءات خارجية هادئة بأسلوب حياة راقي.'] },
      { name: 'Marina', desc: ['تمتد على ساحل دبي اللامع، تجمع بين طاقة المدينة وهدوء الواجهة البحرية.', 'مراسي خاصة وممشات خلابة مع إطلالة مستمرة على الماء.'] },
      { name: 'Dubai Hills', desc: ['تجمع بين الطبيعة والتحضر بطرق مشجرة وملاعب غولف ومساكن مصممة بإتقان.', 'حياة تجمع بين الصحة والأناقة والمجتمع.'] },
      { name: 'Arabian Ranches', desc: ['فيلات أنيقة وشوارع مشجرة وفضاءات مفتوحة تجعل الخصوصية والهدوء الطابع المميز.', 'حدائق خضراء ومرافق اجتماعية مصممة للعائلات.'] },
    ],
  },
  sell: {
    heroBadge: 'أدرج عقارك',
    heroHeadline: 'شارك',
    heroAccent: 'Victory Homes',
    heroSub: 'أدرج عقارك مع فريقنا المتخصص للبيع أو الإيجار. نتولى كل شيء من التقييم حتى الإغلاق.',
    formBadge: 'لمالكي العقارات',
    formHeading: 'أدرج عقارك معنا',
    formSub: 'املأ النموذج وسيتولى فريقنا كل شيء — من التقييم حتى الإغلاق.',
    tabSell: '🏷️ بيع',
    tabRent: '🔑 إيجار',
    sectionContact: 'بيانات التواصل',
    sectionProperty: 'تفاصيل العقار',
    sectionDocs: 'الوثائق القانونية',
    sectionPhotos: 'صور العقار',
    fullName: 'الاسم الكامل',
    email: 'البريد الإلكتروني',
    phone: 'رقم الهاتف',
    whatsapp: 'واتسآب (اختياري)',
    propertyType: 'نوع العقار',
    selectType: '— اختر النوع —',
    emirate: 'الإمارة',
    selectEmirate: '— اختر الإمارة —',
    community: 'المجتمع / المنطقة',
    subCommunity: 'المجتمع الفرعي / المبنى',
    bedrooms: 'غرف النوم',
    bathrooms: 'دورات المياه',
    select: '— اختر —',
    areaSqFt: 'المساحة (قدم مربع)',
    floor: 'الطابق',
    furnishing: 'التأثيث',
    completion: 'حالة الإنجاز',
    ready: 'جاهز',
    offPlan: 'على الخارطة',
    askingPrice: 'سعر الطلب',
    rentAmount: 'مبلغ الإيجار (سنوياً)',
    priceHint: 'أدخل المبلغ بدون فواصل. يجب أن يعكس السعر القيمة السوقية الحالية.',
    youtubeLink: 'رابط فيديو يوتيوب',
    youtubeHint: 'أضف رابط يوتيوب لعرض عقارك (اختياري)',
    description: 'وصف العقار',
    descPlaceholder: 'صف عقارك — المميزات، المناظر، التحسينات، المرافق القريبة…',
    docsIntro: 'تتحقق هذه الوثائق من الملكية وتيسهل الإدراج. جميع الملفات محفوظة بأمان.',
    titleDeed: 'سند الملكية',
    titleDeedHint: 'سند الملكية الرسمي من دائرة الأراضي والأملاك.',
    floorPlan: 'مخطط الطابق',
    floorPlanHint: 'المخطط المعماري. يفضل PDF أو صورة.',
    passport: 'نسخة جواز السفر',
    passportHint: 'جواز سفر ساري لمالك العقار.',
    privacy: 'خصوصية مضمونة. وثائقك مشفرة ولا يمكن الوصول إليها إلا لفريقنا المعتمد.',
    photosLabel: 'صور العقار',
    photosHint: 'حتى 20 صورة — JPG، PNG، WEBP. الصورة الأولى ستكون الغلاف.',
    photosIntro: 'الصور الجيدة تزيد الاستفسارات بشكل كبير. استخدم صوراً مضيئة واسعة لكل غرفة.',
    dragDrop: 'اسحب وأفلت أو',
    browse: 'تصفح',
    accepted: 'PDF، JPG، PNG مقبولة',
    clickReplace: 'انقر للاستبدال',
    dropPhotos: 'أفلت الصور هنا',
    orClickBrowse: 'أو انقر للتصفح',
    upTo20: 'حتى 20 صورة',
    photosAdded: (n) => `تمت إضافة ${n} صورة`,
    submitSale: '🚀 إرسال عرض البيع',
    submitRental: '🚀 إرسال عرض الإيجار',
    submitting: '⏳ جاري الإرسال…',
    termsNotice: 'بالإرسال، توافق على شروط خدمة Victory Homes.',
    successTitle: 'تم إرسال العرض!',
    successDesc: 'سيراجع فريقنا ويتواصل معك خلال',
    successHours: '24 ساعة',
    submitAnother: 'إرسال آخر',
    errName: 'الاسم الكامل مطلوب',
    errEmail: 'بريد إلكتروني صحيح مطلوب',
    errPhone: 'رقم الهاتف مطلوب',
    errPropType: 'اختر نوع العقار',
    errEmirate: 'اختر الإمارة',
    errPrice: 'سعر الطلب مطلوب',
    errRent: 'مبلغ الإيجار مطلوب',
    errPhotos: 'مطلوب صورة واحدة على الأقل',
  },
  props: {
    heroBadge: 'عقارات الإمارات',
    listingCount: (n) => `${n} عقار متاح`,
    tabBuy: 'شراء',
    tabRent: 'إيجار',
    portfolio: 'محفظتنا',
    forSale: 'عقارات للبيع',
    forRent: 'عقارات للإيجار',
    listYourProperty: 'أدرج عقارك ←',
    buy: {
      badge: 'عقارات للبيع',
      headline: 'اعثر على',
      accent: 'عقارك المثالي',
      sub: 'اكتشف قوائم بيع موثقة ومختارة بعناية من خبرائنا عبر دول الإمارات.',
    },
    rent: {
      badge: 'عقارات للإيجار',
      headline: 'اعثر على',
      accent: 'عقارك المثالي للإيجار',
      sub: 'تصفح قوائم إيجار مختارة بعناية ضمن محفظة Victory Homes.',
    },
    enquireNow: 'استفسر الآن ←',
    noMatchTitle: 'لا توجد نتائج تطابق فلتراتك',
    noMatchDesc: 'حاول تعديل الميزانية أو النوع أو المنطقة.',
    clearFilters: 'مسح جميع الفلاتر',
    emptyBuy: 'لا توجد عقارات مدرجة للبيع حالياً',
    emptyRent: 'لا توجد عقارات مدرجة للإيجار حالياً',
    emptyDesc: () => 'حافظتنا تتجدد باستمرار — يرجى المتابعة قريباً أو التواصل معنا مباشرة.',
    speakAgent: 'تحدث مع وكيل ←',
    listProp: 'أدرج عقارك',
    exploreOther: 'استكشف عقارات أخرى',
    otherForSale: 'عقارات أخرى متاحة للبيع',
    otherForRent: 'عقارات أخرى متاحة للإيجار',
    otherDesc: 'بينما نوفر هذه الفئة، إليك عقارات أخرى من محفظتنا.',
    ctaBadge: 'هل أنت مستعد؟',
    ctaHeading: 'هل لديك عقار للإدراج؟',
    ctaDesc: 'خبراؤنا يتولون كل شيء من التقييم حتى الإغلاق. أدرج عقارك مع Victory Homes اليوم.',
    contactUs: 'تواصل معنا',
  },
  featured: {
    tag: 'عقارات حصرية',
    heading: 'استكشف العقارات الحصرية مع الإمارات',
    desc: 'اكتشف أرقى المنازل الفاخرة وأفضل الفرص العقارية مع الإمارات. ادخل إلى حياة تليق بك.',
  },
  partners: {
    tag: 'شركاؤنا',
    heading: 'عقارات من كبار المطورين في الإمارات',
    learnMore: 'اعرف أكثر',
    learnMoreArrow: 'اعرف أكثر ←',
    oasis: { title: 'واحة حدائق الفلل', desc: 'منازل معاصرة فسيحة مع حدائق خاصة وساحات مظللة وتصاميم مستوحاة من الطبيعة تبعث على السلام والأناقة.' },
    ghaf:  { title: 'غاف وودز دبي', desc: 'ضاحية سكنية منخفضة الكثافة بمنازل صديقة للبيئة ومساحات مخصصة للمشاة وغطاء أخضر وفير — مصممة للعيش الصحي طويل الأمد.' },
    nad:   { title: 'ند الشبا', desc: 'حي سكني حصري بفلل فسيحة في بيئة هادئة، مشهور بالخصوصية والمساحات الخضراء وقربه من أبرز معالم دبي.' },
    district: { title: 'ديستريكت ون، دبي', desc: 'مجمع سكني فائق الفخامة بفلل وقصور أنيقة تطل على البحيرات الكريستالية والمساحات الخضراء — صُمِّم للخصوصية والابتذال.' },
  },
  media: {
    tag: 'التغطية الإعلامية',
    heading: 'في دائرة الأضواء الإعلامية',
    readArticle: 'اقرأ المقال',
  },
  newsletter: {
    badge: 'ابقَ على اطلاع',
    heading: 'تقدم على سوق العقارات في دبي',
    desc: 'احصل على قوائم حصرية ورؤى السوق وفرص الاستثمار في صندوق بريدك — قبل أن تصل إلى السوق.',
    placeholder: 'أدخل بريدك الإلكتروني',
    btn: 'اشترك ←',
    privacy: '🔒 لا بريد عشوائي. إلغاء الاشتراك في أي وقت. بياناتك بأمان.',
    success: '✓ تم اشتراكك! أهلاً في مجتمع فيكتوري هومز.',
    error: 'يرجى إدخال عنوان بريد إلكتروني صحيح.',
  },
  nav: {
    home: 'الرئيسية', properties: 'عقارات', buy: '🏡 شراء', rent: '🔑 إيجار',
    sellRent: 'بيع/إيجار', offplan: 'على الخارطة', services: 'الخدمات',
    holidayHomes: 'منازل العطلات', propertyManagement: 'إدارة العقارات',
    fitOut: 'أعمال التجهيز والتجديد، نقل وتغليف الأثاث',
    legalAssistance: 'المساعدة القانونية',
    valuation: 'تقييم العقارات',
    calculators: 'الرهن العقاري',
    transactions: 'المعاملات',
    mortgage: 'حاسبة الرهن العقاري', contact: 'اتصل بنا', roiCalc: 'حاسبة العائد',
    areaIntelligence: 'ذكاء المناطق',
  },
  valuation: {
    heroTitle: 'تقييم السوق المجاني للعقارات',
    heroDesc: 'تفكر في البيع؟ احصل على تقييم فوري دقيق مبني على البيانات لقيمة عقارك الحالية من خبرائنا.',
    successTitle: 'تم استلام الطلب!',
    successDesc: 'سيقوم خبراء التقييم لدينا بمراجعة تفاصيل عقارك والاتصال بك قريباً.',
    submitAnother: 'إرسال طلب آخر',
    fullName: 'الاسم الكامل *',
    phone: 'رقم الهاتف *',
    email: 'البريد الإلكتروني',
    propType: 'نوع العقار *',
    selectType: 'اختر النوع',
    location: 'الموقع / المجمع *',
    locPlaceholder: 'مثال: دبي مارينا',
    bedrooms: 'غرف النوم',
    select: 'اختر',
    area: 'المساحة المبنية (قدم مربع)',
    areaPlaceholder: 'مثال: 1500',
    submit: 'احصل على التقييم المجاني',
    submitting: 'جاري الإرسال...',
    fail: 'فشل إرسال الطلب. يرجى المحاولة مرة أخرى.'
  },
  recentlySold: {
    title: 'العقارات المباعة مؤخراً',
    desc: 'مجموعة مختارة من أحدث معاملاتنا الناجحة. جرب فرق فيكتوري هومز.',
    badge: 'مباع',
    beds: 'غرف'
  },
  trust: {
    clientStories: 'قصص العملاء',
    hearFromClients: 'استمع إلى عملائنا',
    videoUnavailable: 'الفيديو غير متوفر',
    trackRecord: 'سجل حافل',
    provenSuccess: 'نجاح مثبت'
  },
  areaIntelligence: {
    heroBadge: 'ذكاء مناطق دبي',
    heroLine1: 'رؤى مدعومة بالبيانات لـ',
    heroAccent: 'كل حي في دبي.',
    heroSub: 'استكشف اتجاهات الأسعار والعوائد الإيجارية وتحليلات الاستثمار المدعومة بالذكاء الاصطناعي عبر أبرز مجتمعات دبي.',
    modeBuy: 'شراء',
    modeRent: 'إيجار',
    modeOffplan: 'على الخارطة',
    filterTitle: 'الفلاتر والمقاييس',
    heatmapLabel: 'مقياس الخريطة',
    chartAreasLabel: 'مناطق الرسم البياني',
    selectAll: 'الكل',
    selectNone: 'لا شيء',
    loading: 'جاري تحميل بيانات المناطق…',
    mapsKeyMissing: 'مطلوب مفتاح Google Maps API',
    mapsKeyHint: 'أضف VITE_GOOGLE_MAPS_API_KEY إلى ملف .env وأعد التحميل.',
    mapFailedLoad: 'فشل تحميل الخريطة. تحقق من مفتاح API.',
    mapLoading: 'جاري تحميل الخريطة…',
    legendSelectedArea: '⬤ المنطقة المحددة',
    legendSelectedDesc: 'الفقاعة البيضاء = تحديدك الحالي',
    legendLow: { avgPrice: 'سعر أدنى', rentalYield: 'عائد أدنى', demandScore: 'طلب منخفض', avgPricePerSqft: 'سعر/قدم² أدنى' },
    legendHigh: { avgPrice: 'سعر أعلى', rentalYield: 'عائد أعلى', demandScore: 'طلب مرتفع', avgPricePerSqft: 'سعر/قدم² أعلى' },
    activeProjects: 'مشاريع نشطة',
    nearbyLandmarks: '📍 المعالم القريبة',
    kpiAvgPrice: 'متوسط السعر',
    kpiPricePerSqft: 'السعر / قدم²',
    kpiGrossYield: 'العائد الإجمالي',
    kpiDemandScore: 'مؤشر الطلب',
    aiInsightTitle: '✦ تحليل السوق بالذكاء الاصطناعي',
    aiGenerate: 'توليد ←',
    aiAnalysing: 'جاري تحليل بيانات السوق…',
    aiKeyMissing: 'أضف GEMINI_API_KEY إلى backend/.env لتفعيل التحليلات.',
    aiPrompt: 'انقر على "توليد" للحصول على تحليل استثماري مدعوم بالذكاء الاصطناعي لهذه المنطقة.',
    browseOffplan: (name) => `تصفح العقارات على الخارطة في ${name} ←`,
    viewResale: 'عرض عقارات إعادة البيع ←',
    priceTrendBadge: 'اتجاه السعر',
    priceTrendTitle: 'السعر لكل قدم² على 12 شهرًا (درهم)',
    priceTrendSub: 'اتجاه 12 شهر استناداً إلى إجمالي بيانات السوق',
    rentalYieldBadge: 'العائد الإيجاري',
    rentalYieldTitle: 'العائد الإيجاري الإجمالي حسب المنطقة (%)',
    rentalYieldSub: 'استناداً إلى متوسط الإيجار السنوي مقابل متوسط سعر الشراء',
    tooltipYield: (val, name) => [`${val}% عائد إجمالي`, name],
    comparisonBadge: 'مقارنة المناطق',
    comparisonTitle: 'قارن حتى 3 مناطق',
    comparisonSub: 'اختر مناطق أدناه للمقارنة جنباً إلى جنب',
    comparisonPlaceholder: 'اختر المناطق أعلاه لعرض المقارنة',
    colMetric: 'المقياس',
    rowAvgPrice: 'متوسط السعر',
    rowPricePerSqft: 'السعر / قدم²',
    rowGrossYield: 'العائد الإجمالي',
    rowDemandScore: 'مؤشر الطلب',
    rowActiveProjects: 'المشاريع النشطة',
    rowMinEntry: 'أدنى سعر دخول',
    rowMaxPrice: 'أعلى سعر',
    best: 'الأفضل',
    metricAvgPrice: 'متوسط السعر',
    metricRentalYield: 'العائد الإيجاري',
    metricDemand: 'الطلب',
    metricPricePerSqft: 'السعر/قدم²',
  },
  hero: {
    slide1H: 'حيث تلتقي البيانات الذكية والإرشاد المتميز والثقة الإنسانية.',
    slide1P: 'فيكتوري هومز هي أول وساطة عقارية في الإمارات تساعد الناس على اكتشاف الحياة التي يريدونها قبل أن يجدوا المنزل الذي يحتاجونه.',
    slide1Btn: 'استكشف الآن',
    slide2H: 'عقارات واجهة مائية حصرية.',
    slide2P: 'اختبر الرفاهية اللامثيل على أكثر الجزر الاصطناعية شهرة في العالم في جزيرة النخلة.',
    slide2Btn: 'استكشف النخلة',
    slide3H: 'المستقبل يبدأ من هنا.',
    slide3P: 'باستخدام البيانات البيئية والنمذجة التنبؤية، نوصل الناس بمجتمعات رائدة في مرسى دبي.',
    slide3Btn: 'اكتشف المارينا',
    slide4H: 'ابحث عن الحياة، لا فقط عن المنزل.',
    slide4P: 'اكتشف ملاذاً خاصاً محاطاً بالبحيرة الكريستالية الأسطورية وأميال من المساحات الخضراء في ديستريكت ون.',
    slide4Btn: 'شاهد ديستريكت ون',
  },
  stats: {
    impact: 'تأثير أعمالنا',
    sold: 'إجمالي المبيعات 2020–2024',
    lifetime: 'حجم مبيعات إجمالي',
    current: 'حجم القوائم الحالية',
  },
  sellTestimonials: {
    tag: 'آراء العملاء',
    heading: 'بع عقارك مع فيكتوري هومز بسرعة وكفاءة',
    desc: 'استمتع بعملية سلسة وشفافة مصممة لتعظيم قيمة عقارك مع تقليل التعقيدات. بع بذكاء وبسرعة.',
  },
  team: {
    tag: 'فريقنا',
    heading: 'تواصل مع كبار خبراء العقارات في الإمارات',
    desc: 'تعرف على وكلائنا المتميزين في فيكتوري هومز — محترفون ذوو خبرة لمرافقتك في كل خطوة.',
    btn: 'تعرف على الفريق كاملاً →',
  },
  goldenVisa: {
    badge: '🇦🇪 مزايا المستثمر',
    heading: 'التأشيرة الذهبية الإماراتية',
    headingGold: 'عبر الاستثمار العقاري',
    desc: 'استثمر في عقارات الإمارات بقيمة <strong>مليوني درهم أو أكثر</strong> واحصل على <strong>إقامة إماراتية متجددة لمدة 10 سنوات</strong> — لك ولعائلتك.',
    cta: 'تحقق من أهليتي →',
    benefitsHeading: 'لماذا تُعدّ التأشيرة الذهبية فرصة استثنائية',
    benefitsSubheading: 'تفتح التأشيرة الذهبية الإماراتية أبواباً لا توفرها معظم دول العالم.',
    stepsHeading: 'كيف تحصل على تأشيرتك الذهبية',
    stepsSubheading: '4 خطوات بسيطة — فريقنا يرشدك في كل خطوة',
    stepCtaHeading: 'هل أنت مستعد لتأمين تأشيرتك الذهبية؟',
    stepCtaDesc: 'سيحدد مستشارونا العقار المناسب لميزانيتك وأهدافك.',
    stepCtaBtn: 'تحدث مع مستشار',
    yearVisa: 'سنوات إقامة',
    minValue: 'الحد الأدنى لقيمة العقار',
    benefits: {
      b1t: 'إقامة لمدة 10 سنوات', b1d: 'احصل على تأشيرة ذهبية عبر شراء عقار بقيمة مليوني درهم أو أكثر.',
      b2t: 'كفالة الأسرة', b2d: 'اكفل زوجك وأبناءك ووالديك تحت نفس التأشيرة دون طلبات منفصلة.',
      b3t: 'لا تحتاج كفيلاً', b3d: 'عش واعمل وادرس في الإمارات دون الحاجة إلى صاحب عمل أو كفيل محلي.',
      b4t: 'قابلة للتجديد إلى ما لا نهاية', b4d: 'طالما تحتفظ بالعقار المؤهل، تتجدد التأشيرة الذهبية تلقائياً.',
      b5t: 'حرية التنقل العالمي', b5d: 'استمتع بامتيازات الدخول المتعدد والإقامة خارج الإمارات لفترات مطوّلة.',
      b6t: 'أمان الاستثمار', b6d: 'العقار الإماراتي أصل من الدرجة الأولى — اجمع بين إقامة رفيعة وعوائد رأسمالية قوية.',
    },
    steps: {
      s1: 'اشترِ عقاراً بقيمة لا تقل عن مليوني درهم',
      s2: 'احصل على سند ملكية من دائرة الأراضي والأملاك في دبي',
      s3: 'تقدم بالطلب عبر الهيئة الاتحادية للهوية أو إدارة الإقامة وشؤون الأجانب بمساعدة فريقنا',
      s4: 'استلم تأشيرتك الذهبية لمدة 10 سنوات وبطاقة الهوية الإماراتية',
    },
  },
  blog: {
    tag: 'المدونة',
    heading: 'رؤى وأخبار من مدونة عقارات الإمارات',
    desc: 'احصل على أحدث أخبار السوق والنصائح والرؤى الخبراء في عقارات دبي.',
    readMore: 'تابع القراءة',
  },
  evo: {
    statsBadge: 'دبي بالأرقام',
    statsHeading: 'تطور سوق العقارات في دبي',
    statsDesc: 'من ميناء تجاري إقليمي إلى أكثر أسواق العقارات ديناميكية في العالم خلال عقدين فقط.',
    timelineBadge: 'القصة',
    timelineHeading: 'كيف أصبحت دبي الوجهة العقارية الأولى في العالم',
    timelineCTA: 'هل تريد معرفة إلى أين يتجه سوق دبي العقاري؟',
    timelineBtn: 'تحدث مع خبير السوق →',
    stats: {
      s1l: 'صفقة عقارية في 2024', s2l: 'إجمالي قيمة المبيعات بالدرهم 2024',
      s3l: 'نمو أسعار العقارات منذ 2020', s4l: 'جنسية تعيش في دبي',
    },
    timeline: {
      t1t: 'قانون التملك الحر', t1d: 'سمحت دبي للأجانب بتملك العقارات في مناطق التملك الحر مما أطلق موجة الاستثمار الأولى.',
      t2t: 'تحول الأفق', t2d: 'افتُتح برج خليفة وأصبحت دبي أكثر المدن الحديثة شهرة في العالم.',
      t3t: 'إطلاق التأشيرة الذهبية', t3d: 'أطلقت الإمارات برنامج التأشيرة الذهبية لمدة 10 سنوات مما عزز الطلب على عقارات 2 مليون درهم فأكثر.',
      t4t: 'سوق قياسي', t4d: 'أدى التعافي بعد الجائحة إلى ارتفاع غير مسبوق بأكثر من 60٪ في الأسعار.',
      t5t: 'مستويات قياسية جديدة', t5d: 'سجلت دبي أكثر من 96,000 صفقة بقيمة 411 مليار درهم متجاوزة كل الأرقام السابقة.',
      t6t: 'مخطط دبي 2040 العمراني', t6d: 'يستهدف المخطط مضاعفة المساحات الخضراء و5 مراكز حضرية وتعداد سكاني 5.8 مليون بحلول 2040.',
    },
  },
  txn: {
    badge: 'بدعم من DXBinteract',
    heading: 'تقارير معاملات دبي العقارية',
    desc: 'اطلع على بيانات دائرة الأراضي والأملاك الحية — كل صفقة مسجلة، كل سعر متتبع، كل اتجاه مرسوم.',
    live: 'بيانات دائرة الأراضي الحية',
    openPlatform: 'افتح المنصة الكاملة ↗',
    viewReport: 'عرض التقرير →',
    ctaHeading: 'هل تريد تقريراً مخصصاً لمنطقة بعينها؟',
    ctaDesc: 'يمكن لمستشارينا استخراج بيانات المنطقة وتحليلها من أجل استثمارك.',
    ctaBtn: 'اسأل مستشاراً',
    reports: {
      r1l: 'التقرير اليومي', r1d: 'كل معاملة تسجلها دائرة الأراضي — تُحدَّث يومياً.',
      r2l: 'التقرير الأسبوعي', r2d: 'ملخص أسبوعي لأحجام المبيعات والأسعار واتجاهات المناطق.',
      r3l: 'التقرير الشهري', r3d: 'تحليل معمق للأداء الشهري عبر جميع أنواع العقارات.',
      r4l: 'التقرير الربع سنوي', r4d: 'تحليل ربع سنوي: تحولات الأسعار والمناطق الرائدة ونشاط المستثمرين.',
      r5l: 'التقرير السنوي', r5d: 'نظرة شاملة على السوق طوال العام: صفقات قياسية ومجتمعات ناشئة وتوقعات.',
      r6l: 'خريطة أسعار المناطق', r6d: 'خريطة حرارية تفاعلية تعرض السعر لكل قدم مربع في جميع مجتمعات دبي.',
    },
  },
  cta: {
    buying: 'ابدأ الشراء', selling: 'ابدأ البيع', contact: 'اتصل بنا',
    findOut: 'اكتشف المزيد', comingSoon: 'قريباً',
  },
  offplanPromo: {
    badge: 'عقارات على الخارطة',
    heading: 'مشاريع جديدة وصفقات حصرية ما قبل الإطلاق',
    desc: 'احجز وحداتك في أكثر التطويرات المطلوبة في دبي — قبل نفادها. مؤهلة للتأشيرة الذهبية من 2 مليون درهم.',
    btn: 'استكشف العقارات على الخارطة →',
  },
  topCommunities: {
    badge: 'رؤى السوق',
    heading: 'أفضل المجمعات في دبي',
    desc: 'رؤى استراتيجية للمستثمرين والمستخدمين النهائيين (2026-2027)',
    tabs: {
      roi: 'قادة العائد على الاستثمار',
      villas: 'الفلل والتاون هاوس',
      budget: 'حسب الميزانية',
      strategy: 'دليل الاستراتيجية'
    },
    roi: {
      title: 'أفضل المجمعات للعائد على الاستثمار (2026–2027)',
      desc: 'تقدم هذه المناطق باستمرار عوائد إيجارية قوية وزيادة في رأس المال.',
      list: [
        'قرية جميرا الدائرية',
        'دبي الجنوب',
        'أرجان',
        'واحة دبي للسيليكون',
        'مدينة دبي الرياضية',
        'الخليج التجاري',
        'دبي مارينا'
      ],
      insightTitle: 'رؤية رئيسية',
      insights: [
        'قرية جميرا الدائرية + أرجان = أعلى العوائد (6–9%)',
        'دبي مارينا + الخليج التجاري = عوائد أقل ولكن تقدير أقوى للأسعار والسيولة'
      ]
    },
    villas: {
      title: 'أفضل المجمعات للفلل / التاون هاوس',
      desc: 'تركز على المستخدمين النهائيين، العائلات، والعيش طويل الأمد.',
      list: [
        'دبي هيلز استيت',
        'المرابع العربية',
        'تلال الغاف',
        'داماك هيلز',
        'ذا فالي',
        'مدن',
        'تاون سكوير'
      ],
      insightTitle: 'رؤية رئيسية',
      insights: [
        'دبي هيلز = التوازن الأفضل (الموقع + الجودة)',
        'تلال الغاف = مجمع أسلوب الحياة الراقي',
        'تاون سكوير / ذا فالي = فلل للمبتدئين'
      ]
    },
    budget: {
      title: 'أفضل المجمعات حسب الميزانية',
      categories: [
        {
          name: 'المبتدئين',
          range: '500 ألف – 900 ألف درهم',
          areas: ['المدينة العالمية', 'دبي الجنوب', 'ديسكفري جاردنز', 'مدينة دبي للإنتاج', 'ليوان'],
          bestFor: 'المستثمرون لأول مرة، أعلى عائد إيجاري'
        },
        {
          name: 'السوق المتوسطة',
          range: '900 ألف – 2 مليون درهم',
          areas: ['قرية جميرا الدائرية', 'أرجان', 'الفرجان', 'واحة دبي للسيليكون', 'خور دبي'],
          bestFor: 'التوازن بين العائد على الاستثمار وزيادة رأس المال'
        },
        {
          name: 'المستوى الأعلى / الفاخر',
          range: '2 مليون – 5 مليون درهم',
          areas: ['الخليج التجاري', 'دبي مارينا', 'دبي هيلز استيت', 'نخلة جميرا (الوحدات الابتدائية)'],
          bestFor: 'السيولة + الطلب القوي على إعادة البيع'
        },
        {
          name: 'الفاخرة جداً',
          range: '5 مليون درهم+',
          areas: ['وسط مدينة دبي (داون تاون)', 'نخلة جميرا', 'تلال الإمارات (إيميريتس هيلز)', 'ديستريكت ون', 'جزيرة خليج جميرا'],
          bestFor: 'الحفاظ على رأس المال + أصول المرموقة'
        }
      ]
    },
    strategy: {
      title: 'دليل الاستراتيجية البسيط',
      guide: [
        { goal: 'أقصى عائد على الاستثمار', action: 'قرية جميرا الدائرية، أرجان، دبي الجنوب' },
        { goal: 'استثمار آمن', action: 'دبي هيلز، مارينا' },
        { goal: 'التقدير الفاخر', action: 'نخلة جميرا، وسط مدينة دبي' },
        { goal: 'السكن العائلي', action: 'المرابع العربية، تلال الغاف' }
      ]
    }
  },
  servicesPage: {
    "heroTag": "خدمات فيكتوري",
    "whyChoose": "لماذا تختار {service} لدينا؟",
    "form": {
        "fullName": "الاسم الكامل",
        "email": "البريد الإلكتروني",
        "phone": "رقم الهاتف",
        "detailsOpt": "تفاصيل العقار/الوحدة (اختياري)",
        "messageOpt": "رسالة إضافية أو متطلبات",
        "submitRequest": "تقديم الطلب",
        "submitting": "جاري التقديم...",
        "successTitle": "تم استلام الطلب!",
        "successDesc": "شكراً لتواصلك بخصوص {service}. سيقوم فريقنا بمراجعة طلبك والتواصل معك قريباً.",
        "submitAnother": "تقديم طلب آخر",
        "errors": {
            "nameReq": "يرجى إدخال اسمك الكامل",
            "emailReq": "يرجى إدخال بريد إلكتروني صحيح",
            "phoneReq": "يرجى إدخال رقم هاتفك",
            "failSub": "فشل تقديم الطلب. يرجى المحاولة مرة أخرى لاحقاً."
        },
        "placeholders": {
            "name": "مثال: أحمد محمد",
            "email": "you@example.com",
            "phone": "+971 50 123 4567",
            "details": "مثال: شقة غرفتين في داون تاون دبي",
            "message": "كيف يمكننا مساعدتك؟"
        }
    },
    "services": {
        "holiday-homes": {
            "title": "بيوت العطلات",
            "heroSub": "عظّم عوائد عقارك من خلال إدارتنا المتميزة للتأجير قصير المدى.",
            "desc": "حوّل عقارك إلى بيت عطلات مربح دون أي عناء. نتولى التسويق، إدارة الضيوف، والصيانة لضمان أفضل العوائد. سوق دبي السياحي يوفر عوائد ممتازة للتأجير القصير.",
            "extraDesc": "من الفرش والتصميم الاستراتيجي إلى التصوير الاحترافي وتحسين الإعلانات، استراتيجيتنا تضمن أقصى نسبة إشغال. نقدم دعم للضيوف على مدار الساعة لراحة بالك.",
            "points": [
                "تسعير وتسويق ديناميكي",
                "دعم الضيوف وكونسيرج على مدار الساعة",
                "خدمات تنظيف احترافية",
                "تقارير شهرية للعوائد",
                "مساعدة قانونية والتسجيل"
            ],
            "formTitle": "طلب خدمات بيوت العطلات",
            "formDesc": "أخبرنا كيف يمكننا مساعدتك في أهداف التأجير قصير المدى الخاصة بك."
        },
        "property-management": {
            "title": "إدارة العقارات",
            "heroSub": "خدمات إدارة شاملة لراحة بالك ودخل ثابت.",
            "desc": "نتولى كل شيء من فحص المستأجرين إلى طلبات الصيانة باحترافية وأمان. احمِ أصولك بينما تضمن عوائد إيجارية ثابتة.",
            "extraDesc": "نحن نزيل عنك ضغوط المالك. خدمتنا تشمل التسجيل في إيجاري، تحصيل الإيجار، التفتيش الدوري، والتعامل مع الإصلاحات الطارئة.",
            "points": [
                "فحص شامل للمستأجرين",
                "تحصيل الإيجارات وتقارير مالية",
                "تسجيل إيجاري وامتثال قانوني",
                "تفتيش دوري وصيانة",
                "خدمات تسوية المنازعات"
            ],
            "formTitle": "طلب إدارة عقار",
            "formDesc": "قدم تفاصيلك وسنتواصل معك بخطة إدارة مصممة خصيصاً لك."
        },
        "fit-out": {
            "title": "خدمات التصميم والديكور",
            "heroSub": "غيّر مساحتك مع حلولنا العالمية للتصميم الداخلي والديكور.",
            "desc": "تصميم، تخطيط، وتنفيذ مخصص للمساحات سواء كان تحديث لفيلا فاخرة أو تصميم مكتب حديث.",
            "extraDesc": "يعمل مصممونا ومديرو المشاريع معك من المفهوم إلى التسليم. نحن نضمن دقة التنفيذ والموافقات الرسمية واستخدام أفضل المواد.",
            "points": [
                "مفاهيم تصميم داخلي مخصصة",
                "تخطيط المساحات وتصور ثلاثي الأبعاد",
                "تنفيذ كامل وإدارة المشاريع",
                "الموافقات الرسمية والتصاريح",
                "توريد الأثاث والمواد"
            ],
            "formTitle": "طلب استشارة تصميم",
            "formDesc": "احجز استشارة لمناقشة رؤيتك لعقارك."
        },
        "legal-assistance": {
          title: "المساعدة القانونية",
          heroSub: "توجيه قانوني خبير لمعاملات عقارية آمنة ومتوافقة في الإمارات.",
          desc: "التنقل في قوانين العقارات في دبي يتطلب الدقة. نحن نقدم دعماً قانونياً كاملاً لضمان أن تكون معاملاتك آمنة، متوافقة، وخالية من التوتر.",
          extraDesc: "من التحقق الشامل من الملكية إلى ضمان الامتثال الكامل لمؤسسة التنظيم العقاري (RERA) والعناية الواجبة، يحمي خبراؤنا مصالحك. نوجهك خلال قائمة مراجعة سند البيع وعمليات شراء العقارات.",
          points: ["التحقق من الملكية والعناية الواجبة", "الامتثال لمؤسسة التنظيم العقاري (RERA)", "إعداد قائمة مراجعة سند البيع", "التحقق من شراء العقار", "حل النزاعات والاستشارات"],
          formTitle: "طلب مساعدة قانونية",
          formDesc: "قدم تفاصيلك وسيقوم خبراؤنا القانونيون بالتواصل معك."
        }
    }
},
  footer: {
    letsWork: 'لنعمل معاً',
    email: 'البريد الإلكتروني',
    callWhatsApp: 'هاتف / واتساب',
    ourLocation: 'موقعنا',
    officePhone: 'هاتف المكتب',
    tagline: 'شريكك العقاري الموثوق في دبي. نتخصص في الشراء والبيع والإيجار للعقارات المميزة في الإمارات مع إرشاد خبير في كل خطوة.',
    ourServices: 'خدماتنا',
    usefulLinks: 'روابط مفيدة',
    copyright: '© 2025 فيكتوري هومز. جميع الحقوق محفوظة.',
    serviceLinks: ['عقارات جديدة', 'بع عقارك', 'خدماتنا', 'بيانات صحفية'],
    headline: 'فريقنا من وكلاء العقارات المؤهلين مستعد ومتاح دائماً، في أي وقت وأي مكان.',
  },
  offplanDetail: {
    overview: "نظرة عامة",
    propertyTypes: "أنواع العقارات",
    totalUnits: "إجمالي الوحدات",
    handover: "التسليم",
    startingPrice: "السعر المبدئي",
    startingFrom: "يبدأ من",
    paymentPlan: "خطة الدفع",
    location: "الموقع والاتصال",
    mins: "دقيقة",
    unitType: "نوع الوحدة",
    size: "المساحة",
    availableOptions: "الخيارات المتاحة",
    getBrochure: "الحصول على الكتيب",
    reqDetails: "طلب التفاصيل",
    dlBrochure: "تحميل الكتيب",
    dlFloorPlans: "تحميل المخططات",
    fullName: "الاسم الكامل *",
    emailAdd: "البريد الإلكتروني *",
    phoneNum: "رقم الهاتف",
    reqDesc: "املأ بياناتك لاستلام {type} المشروع لـ {name}.",
    reqSuccess: "تم استلام الطلب",
    reqSuccessDesc: "شكرًا لك. سيقوم أحد المتخصصين لدينا بإرسال الكتيب والمخططات إليك قريبًا.",
    close: "إغلاق",
    submitting: "جاري الإرسال...",
    reqType: "طلب {type}",
    types: {
        Apartment: "شقة",
        Townhouse: "تاون هاوس",
        Villa: "فيلا",
        Penthouse: "بنتهاوس",
        Mansion: "قصر",
        Duplex: "دوبلكس",
        Plot: "أرض"
    },
    tags: {
        waterfront: "واجهة مائية",
        family: "عائلي",
        luxury: "فاخر",
        investment: "استثماري",
        golf: "ملعب جولف",
        urban: "حضري",
        nature: "طبيعة"
    },
    beds: {
        studio: "استوديو",
        br: "غرف نوم",
        units: "وحدات",
        various: "متنوع"
    }
}
,
  offplanExtra: {
        "interested": "هل أنت مهتم؟",
        "readyToSecure": "جاهز لتأمين وحدتك في",
        "advisorGuide": "يمكن لمستشارينا المتخصصين إرشادك خلال الأسعار وخيارات الدفع وعملية الشراء الكاملة — بدون عمولة.",
        "getInTouch": "تواصل معنا",
        "whatsapp": "واتساب",
        "enquire": "استفسر",
        developer: "المطور",
    community: "المجتمع",
    buildingHeight: "ارتفاع المبنى",
    retailSpace: "مساحة التجزئة",
    furnishing: "الأثاث",
    about: "حول",
    investmentOutlook: "النظرة الاستثمارية",
    lifestyle: "نمط الحياة",
    worldClassAmenities: "وسائل راحة عالمية المستوى",
    unitTypes: "أنواع الوحدات",
    floorPlans: "مخططات الطوابق",
    financing: "التمويل",
    typesSuffix: "أنواع",
    sizeRange: "نطاق المساحة",
    units: "وحدات",
    from: "من",
        ofTotalPayment: "من إجمالي الدفعة",
        whyOffPlan: "لماذا قيد الإنشاء؟",
        lowerEntryPrice: "سعر دخول أقل مقارنة بالعقارات الجاهزة",
        spreadPayments: "توزيع المدفوعات خلال فترة البناء",
        capitalAppreciation: "زيادة رأس المال قبل التسليم",
        zeroCommission: "بدون عمولة - شراء مباشر",
        speakToAdvisor: "تحدث إلى مستشار",
        openMap: "افتح الموقع الدقيق في خرائط جوجل",
        nearbyPlaces: "الأماكن المجاورة",
        to: "إلى",
        booking: "حجز",
        installment: "قسط",
        handover: "التسليم",
        areaUnit: "وحدة المساحة",
        currency: "العملة",
        youtubeLink: "رابط فيديو يوتيوب",
        watchVideo: "مشاهدة الفيديو",
        watchTour: "مشاهدة الجولة"
    },
  amenities: {
        "Kids Pool": "مسبح للأطفال",
        "Private Beach Access": "دخول خاص إلى الشاطئ",
        "Marina Access": "وصول إلى المرسى",
        "Outdoor Gym": "صالة رياضية خارجية",
        "Basketball Court": "ملعب كرة سلة",
        "Tennis Court": "ملعب تنس",
        "Padel Court": "ملعب بادل",
        "Cycling Track": "مسار للدراجات",
        "Spa & Wellness Center": "مركز سبا وعافية",
        "Kids Play Area": "منطقة لعب للأطفال",
        "Clubhouse": "نادي",
        "Library": "مكتبة",
        "Retail Outlets": "متاجر تجزئة",
        "Cafes & Restaurants": "مقاهي ومطاعم",
        "Supermarket": "سوبر ماركت",
        "Concierge Service": "خدمة كونسيرج",
        "24/7 Security": "أمن على مدار الساعة",
        "CCTV Surveillance": "مراقبة بالكاميرات",
        "Mosque": "مسجد",
        "Pet Friendly": "صديق للحيوانات الأليفة",
        "Dining Destinations": "وجهات لتناول الطعام",
        "Yoga Studio": "استوديو يوغا",
        "Lush Green Parks": "حدائق خضراء مورقة",
        "Valet Parking": "خدمة صف السيارات",
        "Smart Home Features": "ميزات المنزل الذكي",
        "Sauna & Steam Room": "ساونا وغرفة بخار",
        "Covered Parking": "مواقف مغطاة للسيارات",
        "Landscaped Gardens": "حدائق ذات مناظر طبيعية",
    "Swimming Pool": "حمام سباحة",
    "State-of-the-art Gym": "صالة رياضية حديثة",
    "BBQ Area": "منطقة للشواء",
    "Sports Courts": "ملاعب رياضية",
    "Infinity Pool": "مسبح إنفينيتي",
    "Running Track": "مضمار للجري",
    "Cinema Room": "غرفة سينما",
    "Games Room": "غرفة ألعاب"
}
}

export default ar
